import { companyCodeInContextSelector } from '../../../shared/store/selectors';

export const findCompanyCodeInContext = ({ groupType, groupItems, state }) => {
  let formattedCompanyCode = null;
  if (groupType === 'CC') {
    const companyCodeInContext = companyCodeInContextSelector(state);
    const foundCompanyCode = companyCodeInContext
      ? groupItems.find(companyCode => companyCode.groupItem === companyCodeInContext.value)
      : null;

    if (foundCompanyCode ) {
      formattedCompanyCode = companyCodeInContext;
    }
  }

  return formattedCompanyCode;
};

export const prepareTagsGroups = group => group.subrows
  ? ({
    ...group,
    isOpen: false,
    subrows: group.subrows.map(prepareTagsGroups),
  })
  : group;

export const prepareETRReport = reportData => ({
  ...reportData,
  rateDiffRows: {
    ...reportData.rateDiffRows,
    isOpen: false,
  },
  tagsGroups: reportData.tagsGroups.map(prepareTagsGroups),
});
